exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-name-chooser{align-items:center;display:flex;flex-direction:row}.display-name-chooser>*{margin-right:10px}.display-name-chooser__name{align-items:center;display:flex;flex-direction:row;gap:8px;justify-content:flex-start;align-content:flex-start}.display-name-chooser__name .Mui-focused fieldset{top:-6px !important}.display-name-chooser__name .Mui-focused legend{visibility:visible !important;font-size:13px;color:#fa6422;transform:translate(-2px, -6px) scale(0.9)}.display-name-chooser__name__button{padding:6px}.display-name-chooser__name__button[disabled]{opacity:0.7}.display-name-chooser__name__button__icon{color:#008000}.display-name-chooser__badge{background-color:#fa6422;border-radius:4px;color:#fff;font-size:12px;font-size:0.75rem;padding:2px 3px 0}\n", ""]);

// exports
exports.locals = {
	"display-name-chooser": "display-name-chooser",
	"display-name-chooser__name": "display-name-chooser__name",
	"Mui-focused": "Mui-focused",
	"display-name-chooser__name__button": "display-name-chooser__name__button",
	"display-name-chooser__name__button__icon": "display-name-chooser__name__button__icon",
	"display-name-chooser__badge": "display-name-chooser__badge"
};